import * as React from "react";
import Header from "./Header";
import ClassementMail from "./ClassementMail";
import {makeStyles} from "@fluentui/react-components";
import {useEffect} from "react";
import Connexion from "./Connexion";
import Footer from "./Footer";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
    },
    content: {
        flex: 1,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
    },
    center: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyItems: "start",
        paddingTop: "20px",
        paddingLeft: "20px",
        paddingRight: "20px",
    },
});

const App: React.FC = () => {
    const styles = useStyles();

    const [modeMaintenance, setModeMaintenance] = React.useState(false);

    const [estConnecte, setEstConnecte] = React.useState(false);

    useEffect(() => {
        fetch(`https://zlawyerapi.azurewebsites.net/parametres/status-complement-word`)
            .then((response) => {
                if (!response.ok) {
                    return {'succes': false};
                }
                return response.json();
            })
            .then((data) => {
                setModeMaintenance(data['succes'] === false);
            }).catch(() => {
        });

        setEstConnecte(!!localStorage.getItem("zLawyerToken"));
    }, []);

    return (
        <div className={styles.root}>
            <Header/>
            <div className={styles.content}>
                {estConnecte && !modeMaintenance ? <ClassementMail/> : <Connexion/>}
                {modeMaintenance && <div className={styles.center}>
                    <div className="text-center">
                        <h3 className="mt-2 text-sm font-semibold text-gray-900">Complément en maintenance</h3>
                        <p className="my-4 text-sm text-gray-500">
                            Le complément zLawyer est actuellement en maintenance. Veuillez réessayer ultérieurement.
                        </p>
                    </div>
                </div>}
            </div>
            <Footer/>
        </div>
    );
};

export default App;
